import { Dictionary } from '@/dictionary/Dictionary'

const barcodesPrintDict: Array<Dictionary> = []

for (const code of ['A4', 'A5', 'A6', 'A7']) {
    barcodesPrintDict.push({ code: code, name: code })
}

export { barcodesPrintDict }
